<template>
  <div>
    <div
      :class="wrapperClass"
      class="overview-navigation-block"
      @click="simulateClickOnLink"
    >
      <div class="overview-navigation-block__circle-wrapper">
        <div class="overview-navigation-block__element-container">
          <div class="overview-navigation-block__link-circle">
            <svgicon
              name="Navigation/ArrowRight"
              class="overview-navigation-block__link-circle-icon"
            />
          </div>
          <div class="overview-navigation-block__image-wrapper">
            <epi-property
              id="Image"
              text="Bild"
            />

            <epi-picture
              :image="image"
              :sizes="dimensions"
              :use-picture="false"
              :auto-aspect-ratio="false"
            />
          </div>
        </div>
      </div>

      <div class="overview-navigation-block__content">
        <h3
          v-if="buttonLabel"
          class="overview-navigation-block__heading"
        >
          <a
            ref="navigationBlockLink"
            v-edit="'Url'"
            :href="url"
            class="overview-navigation-block__link"
            @click.stop
          >{{ buttonLabel }}</a>
        </h3>
        <div
          v-if="preamble"
          class="overview-navigation-block__preamble"
        >
          {{ preamble }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "#/Navigation/ArrowRight"

export default {
  name: "OverviewNavigationBlock",
  props: {
    image: {
      type: Object,
      default: null
    },
    buttonLabel: {
      type: String,
      default: ""
    },
    preamble: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    displayAsPrimary: {
      type: Boolean,
      default: true
    },
    displayStyle: {
      type: String,
       default: "default",
      validator (value) {
        return ["default", "large", "small"].includes(value)
      }
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          height: 104,
          width: 104
        },
        medium: {
          height: 152,
          width: 152
        },
        large: {
          height: 152,
          width: 152
        }
      }
    }
  },
  computed: {
    wrapperClass () {
      return `${this.displayAsPrimary ? 'primary' : ''} ${this.displayStyle}`
    }
  },
    methods: {
    simulateClickOnLink () {
      this.$refs.navigationBlockLink.click()
    },
  },
}
</script>
<style lang="scss">
.overview-navigation-block {
  min-height: 9.5rem;
  display: flex;
  text-decoration: none;
  border-radius: 2rem;
  overflow: hidden;
  background: $color-white;
  height: 100%;
  width: 100%;

  &.large {
    flex-direction: column;
  }

  &.small {
    @include media-breakpoint-up(md) {
      display: flex;
    }

    @include media-breakpoint-up(lg) {
      display: block;
    }
  }

  @include media-breakpoint-up(md) {
    border-radius: 2.5rem;
  }

  &:not(:last-child) {
    margin-bottom: 0.5rem;

    @include media-breakpoint-up(md) {
      margin-bottom: 0;
    }
  }

  &__link-circle {
    width: 2.5rem;
    height: 2.5rem;
    background: $color-red-special;
    border-radius: 5rem;
    position: absolute;
    z-index: 2;
    top: -0.5rem;
    left: -1.2rem;
    overflow: hidden;

    @include addTransition();

    @include media-breakpoint-up(md) {
      top: 1.5rem;
      left: 7.5rem;
      width: 4rem;
      height: 4rem;
    }

    &-icon {
      width: 1.25rem;
      height: 1.25rem;
      fill: $color-secondary-cta-text;
      position: absolute;
      top: 0.625rem;
      left: 0.625rem;

      .primary & {
        fill: $color-white;
      }

      @include media-breakpoint-up(md) {
        width: 2rem;
        height: 2rem;
        top: 1rem;
        left: 1rem;
      }
    }
  }

  &.large &__link-circle {
    top: 1.5rem;
    left: 7.5rem;
    width: 4rem;
    height: 4rem;

    &-icon {
      width: 2rem;
      height: 2rem;
      top: 1rem;
      left: 1rem;
    }
  }

  &.small &__link-circle {
    @include media-breakpoint-up(md) {
      width: 2.5rem;
      height: 2.5rem;
      top: -0.5rem;
      left: -1.2rem;

      &-icon {
        width: 1.25rem;
        height: 1.25rem;
        fill: $color-secondary-cta-text;
        position: absolute;
        top: 0.625rem;
        left: 0.625rem;
      }
    }

    @include media-breakpoint-up(lg) {
      top: 1.5rem;
      left: 7.5rem;
      width: 4rem;
      height: 4rem;

      &-icon {
        width: 2rem;
        height: 2rem;
        top: 1rem;
        left: 1rem;
      }
    }
  }

  &.primary {
    background: $color-turquoise-special;

    .overview-navigation-block__link-circle {
      background: $color-primary-cta;
    }
  }

  @include media-breakpoint-up(md) {
    display: block;

    &.primary {
      .overview-navigation-block__circle-wrapper,
      .overview-navigation-block__content {
        background: $color-turquoise-special;
      }
    }
  }

  &__link {
    @include font(rubrik, 2, "bold");
  }

  &:hover,
  &:focus {
    cursor: pointer;

    .overview-navigation-block__link-circle {
      background: $color-pink-light;

      .svg-icon {
        animation: arrow-exit-right-enter-left 3s ease-in-out infinite;
        fill: $color-white;
      }
    }

    .overview-navigation-block__link {
      color: $color-pink-light;
    }
  }

  &:active {
    .overview-navigation-block__link {
      color: $color-red-dark;
    }
  }

  &__circle-wrapper {
    padding: 1.5rem 0 0 1.5rem;

    @include media-breakpoint-up(md) {
      padding: 0;
    }
  }

  &.large &__circle-wrapper {
    padding: 0;
  }

  &.small &__circle-wrapper {
    @include media-breakpoint-up(md) {
      padding: 1.5rem 0 0 1.5rem;
    }

    @include media-breakpoint-up(lg) {
      padding: 0;
    }
  }

  &__element-container {
    position: relative;
    padding-right: 7.5rem;

    @include media-breakpoint-up(md) {
      padding-right: 0;
      padding-bottom: 12.75rem;
      width: 9.5rem;
      margin: 0 auto;
    }
  }

  &.large &__element-container {
    padding-right: 0;
    padding-bottom: 12.75rem;
    width: 9.5rem;
    margin: 0 auto;
  }

  &.small &__element-container {
    @include media-breakpoint-up(md) {
      padding-right: 7.5rem;
      padding-bottom: 0;
      width: auto;
      margin: 0;
    }

    @include media-breakpoint-up(lg) {
      padding-right: 0;
      padding-bottom: 12.75rem;
      width: 9.5rem;
      margin: 0 auto;
    }
  }

  &__image-wrapper {
    width: 6rem;
    height: 6rem;
    border-radius: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;

    .epi-picture,
    .epi-background-container,
    .empty-image-placeholder {
      border-radius: 100%;
      height: 100%;
    }

    @include media-breakpoint-up(md) {
      top: 2rem;
      left: 0;
      width: 9.5rem;
      height: 9.5rem;
    }
  }

  &.large &__image-wrapper {
    top: 2rem;
    left: 0;
    width: 9.5rem;
    height: 9.5rem;
  }

  &.small &__image-wrapper {
    @include media-breakpoint-up(md) {
      width: 6rem;
      height: 6rem;
      top: 0;
      left: 0;
    }

    @include media-breakpoint-up(lg) {
      top: 2rem;
      left: 0;
      width: 9.5rem;
      height: 9.5rem;
    }
  }

  &__content {
    text-align: left;
    border-radius: 0;
    overflow: hidden;
    padding: 1rem 1.5rem 1rem 0;
    margin: auto 0;

    @include media-breakpoint-up(md) {
      text-align: center;
      padding: 0 2rem 2rem;
      overflow: hidden;
    }
  }

  &.large &__content {
    text-align: center;
    padding: 0 2rem 2rem;
    overflow: hidden;
  }

  &.small &__content {
    @include media-breakpoint-up(md) {
      text-align: left;
      padding: 1rem 1.5rem 1rem 0;
    }

    @include media-breakpoint-up(lg) {
      text-align: center;
      padding: 0 2rem 2rem;
      overflow: hidden;
    }
  }

  &.default &__heading,
  &.small &__heading {
    @include media-breakpoint-up(lg) {
      display: flex;
      justify-content: center;
    }
  }

  &.large &__heading {
    display: flex;
    justify-content: center;
  }

  &__preamble {
    margin: 0;
    max-height: 1.5rem * 7;
    color: $color-grey-dark;
    display: block;
    -webkit-line-clamp: 7;
    overflow: hidden;
    text-overflow: ellipsis;

    @include font(text, 3, "normal");

    @include media-breakpoint-up(md) {
      -webkit-line-clamp: 4;
      max-height: 1.5rem * 4;
      margin: 0.25rem auto 0;
    }
  }

  &.large &__preamble {
    -webkit-line-clamp: 4;
    max-height: 1.5rem * 4;
    margin: 0.25rem auto 0;
  }
}

@keyframes arrow-exit-right-enter-left {
  50% {
    opacity: 1;
    transform: translateX(0);
  }

  75% {
    opacity: 0;
    transform: translateX(150%);
  }

  75.1% {
    opacity: 0;
    transform: translateX(-150%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
